import { ListField } from "@sens/core/type/list"
import { IList } from "./list"

export const INTERNAL_ITEM_FIELDS = [
  "id",
  "createdAt",
  "type",
  "notifiedAt",
  "updated",
  "created",
  "listId",
  "likeCount",
  "isPendingModeration",
  "isFeatured",
]

export const getPossibleFieldsForListItemSubmission = (list: Pick<IList, "fieldDefinitions">): ListField[] => {
  return list.fieldDefinitions?.filter((field) => field.canSubmit) || []
}

// adds
// export const mutateListItems = async (list: ListType, items: ListItemType[]) => {
//   // build new list of items
//   const newItems: ListItemType[] = list.items
//
//   items.forEach((inputItem) => {
//     if (!inputItem.id) {
//       inputItem.id = ulid()
//     }
//     const existingItem = newItems.find((item) => item.id === inputItem.id)
//     if (!existingItem) {
//       // create new item
//       const newItem: ListItemType = {
//         ...inputItem,
//         createdAt: new Date().toISOString(),
//       }
//       newItems.push(newItem)
//       return
//     }
//
//     // update existing item
//     const updatedItem: ListItemType = {
//       ...existingItem,
//       ...inputItem,
//       createdAt: existingItem.createdAt || new Date().toISOString(),
//     }
//     newItems.splice(newItems.indexOf(existingItem), 1, updatedItem)
//   })
//   console.log("new items", newItems)
//
//   const updated = await List.update({ ...input, items: newItems })
//   return updated
// }
